export const toggle = async (path: string, { arg }: { arg: { id: number; isSelected: boolean; token: string; program?: string } }) => {
  const { id, isSelected, token, program = 'drill_team_2024' } = arg;
  try {
    const url = isSelected ? `${import.meta.env.VITE_BASE_URL}${path}${id}` : `${import.meta.env.VITE_BASE_URL}${path}`;
    const method = isSelected ? 'DELETE' : 'POST';
    const response = await fetch(url, {
      method,
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ student_id: id, program }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('Failed to remove student:', error);
  }
};
